import { gql } from '@apollo/client';
import { QUOTE_CALC_VIEW_MODEL_FRAGMENT } from './fragments';

export const QUOTE_CALC_BY_ID = gql`
  query QuoteCalcById($quoteId: ID!) {
    quoteCalc {
      result: byQuoteId(quoteId: $quoteId) {
        error
        success
        entity {
          ...QuoteCalcViewModelFields
        }
      }
    }
  }
  ${QUOTE_CALC_VIEW_MODEL_FRAGMENT}
`;
